import React, { useRef, useState } from 'react';
import {
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
	colors,
} from '@alixpartners/ui-components';
import Highcharts from 'highcharts';
import {
	ExploreButton,
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartList.styles';
import { FONTSTYLE } from 'utils/filterNames';
import HighchartsReact from 'highcharts-react-official';

import { renderToString } from 'react-dom/server';
import Tooltip from '../../Components/Tooltip';

import ExpandedModal from '../../Components/ExpandedModal';
import { useChartContext } from 'contexts/CategoryChartContext';

const PieChart = ({ chartTitle, isParent, chartheight, chartData }) => {
	const [isExpandedView, setIsExpandedView] = useState(false);
	const chartRef = useRef();
	const { state } = useChartContext();
	const { spendBreakdownLoading } = state;

	const options = {
		chart: {
			type: 'pie',
			height: chartheight,
		},
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		title: { text: '' },
		boost: {
			useGPUTranslations: true,
		},

		series: [
			{
				name: 'Series 1',
				data: chartData,
			},
		],
		colors: ['#032E45', '#65CEEB', '#0D3E57', '#448EB4', '#4FAEC6'],
	};

	return (
		<SectionWrapper>
			<Header>
				<Title>{chartTitle}</Title>
				{isParent && (
					<ExploreButton
						title="Explore"
						className="explore"
						onClick={() => setIsExpandedView(true)}
						disabled={chartData.length === 0}
					>
						<ApIcon title="Explore" material={true} iconName="find_in_page" />
					</ExploreButton>
				)}
			</Header>
			{spendBreakdownLoading === true ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{chartData.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							<HighchartsReact
								highcharts={Highcharts}
								options={{
									...options,
									plotOptions: {
										series: {
											animation: false,
											shadow: false,
										},

										pie: {
											dataLabels: {
												enabled: true,
												format: '{point.name} {point.percentage:.1f}%',
												// distance: 20, // Adjust label distance from the pie chart

												distance: -50,
												filter: {
													property: 'percentage',
													operator: '>',
													value: 5,
												},
												softConnector: false,
												style: {
													fontSize: '10px',
													color: `${colors.white}`,
												},
											},
											showInLegend: true,
										},
									},
									legend: {
										align: 'right',
										verticalAlign: 'middle',
										layout: 'vertical',
										labelFormatter: function() {
											return (
												this.name.split(' ')[0] +
												'  ' +
												this.percentage.toFixed(2) +
												'%'
											);
										},
										itemStyle: {
											...FONTSTYLE,
											textOverflow: 'ellipsis',
										},
									},
									tooltip: {
										shared: true,
										useHTML: true,
										backgroundColor: 'rgba(255,255,255, 0.9)',
										borderWidth: 0,
										borderRadius: 2,
										outside: true,
										formatter: function() {
											const { point } = this;
											return renderToString(
												<Tooltip
													tooltipData={point?.tooltip}
													color={point?.color}
												/>
											);
										},
									},
								}}
								ref={chartRef}
							/>
						</>
					)}
					{isExpandedView && (
						<ExpandedModal
							heading={chartTitle}
							show={chartData.length !== 0}
							handleClose={() => setIsExpandedView(state => !state)}
						>
							<PieChart chartheight={'30%'} chartData={chartData} />
						</ExpandedModal>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default React.memo(PieChart);
